import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useTranslation } from "react-i18next";

export const TechicalSupport = ({
    techSupport,
    faq,
}: {
    techSupport: string;
    faq: string;
}) => {
    const { t } = useTranslation();

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger
                asChild
                className="cursor-pointer px-4 py-2 font-normal text-base hover:bg-black hover:text-white"
            >
                <div>{t("Footer.techSupport")}</div>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content
                    className="min-w-[220px] rounded-t-md bg-black
                        shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)]
                        will-change-[opacity,transform] 
                        data-[side=top]:animate-slideDownAndFade
                    "
                    sideOffset={1}
                    side="top"
                >
                    <DropdownMenu.Item
                        className="px-4 pt-4 pb-2 font-normal text-base 
                        cursor-pointer 
                        focus-visble:border-none
                        focus-visible:outline-none"
                    >
                        <a
                            href={faq}
                            className="text-[#9B9B9B] hover:text-white no-underline"
                        >
                            {" "}
                            {t("Footer.readFaq")}
                        </a>
                    </DropdownMenu.Item>
                    <DropdownMenu.Item
                        className="px-4 pt-2 pb-4  font-normal text-base
                        cursor-pointer 
                        focus-visble:border-none
                        focus-visible:outline-none"
                    >
                        <a
                            href={techSupport}
                            className="text-[#9B9B9B] hover:text-white no-underline"
                        >
                            {t("Footer.contactSupport")}
                        </a>
                    </DropdownMenu.Item>
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
};
